<template>
    <div class="session__register_print">
        <component-loading>Printing in progress...</component-loading>
        <div class="session__register_print_cover"></div>
        <div class="container">
            <template v-for="(register, index) in registers">
                <div class="session__register_print_page">
                    <div class="session__register_print_page_main">
                        <div class="session__register_print_page_main_details">
                            <div class="columns">
                                <div class="column">
                                    <div class="session__register_print_page_main_details_customer">{{ loggednInUserCustomerName }}</div>
                                    <div class="session__register_print_page_main_details_workspace">{{ loggednInUserWorkspaceName }}</div>
                                    <div class="session__register_print_page_main_details_event">{{ sessionEventName }}</div>
                                    <div class="session__register_print_page_main_details_session">{{ sessionDateDate }} <span>{{ sessionDateTime }} ({{ getHoursDifference(sessionDateDatetimeStart, sessionDateDatetimeEnd, 'hr') }})</span></div>
                                </div>
                                <div class="column is-narrow">
                                    <div class="session__register_print_page_main_details_logo">
                                        <component-logo></component-logo>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="session__register_print_page_main_table">
                            <session-register-print-table
                                :key="index"
                                :items="register"
                            />
                        </div>
                    </div>
                    <div class="session__register_print_page_footer">
                        <div class="session__register_print_page_footer_page">Page {{ index + 1 }} of {{ registers.length }}</div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>

import SessionRegisterPrintTable from '@/components/ebs/sessions/register/SessionRegisterPrintTable'
import ComponentLogo from '@/components/default/shared/ComponentLogo'
import { jsPDF } from 'jspdf'
import html2canvas from 'html2canvas'
import ComponentLoading from '@/components/default/shared/ComponentLoading'

export default {
  name: 'session-register-print',
  components: {
    ComponentLoading,
    ComponentLogo,
    SessionRegisterPrintTable
  },
  data () {
    return {
      doc: new jsPDF('p', 'pt', 'a4')
    }
  },
  computed: {
    routeParamsRegisterId () {
      return this.$route.params.registerId
    },
    loggednInUserCustomerName () {
      return this.$store.getters.getAuthUserSecondStageTokenDataCustomerName
    },
    loggednInUserWorkspaceName () {
      return this.$store.getters.getAuthUserSecondStageTokenDataWorkspaceName
    },
    sessionEventName () {
      return this.$store.getters.getSessionEventName
    },
    sessionItem () {
      const occurrenceItems = this.$store.getters.getSessionOccurrenceItems
      const selectedOccurrenceItem = occurrenceItems.find(obj => obj.id === this.routeParamsRegisterId)

      return selectedOccurrenceItem
    },
    sessionDates () {
      return this.$store.getters.getSessionDates
    },
    sessionDateDatetimeStart () {
      return this.sessionItem.datetimeStart
    },
    sessionDateDatetimeEnd () {
      return this.sessionItem.datetimeEnd
    },
    sessionDateDate: function () {
      const dateStart = this.sessionItem.dateStartLocal
      return this.toLocaleDateTime(dateStart)
    },
    sessionDateTime: function () {
      const date = this.sessionItem.date
      const timeStart = date + 'T' + this.sessionItem.timeStartLocal
      const timeEnd = date + 'T' + this.sessionItem.timeEndLocal

      return date ? this.toLocaleTime(timeStart) + ' - ' + this.toLocaleTime(timeEnd) : false
    },
    registers () {
      let tableItemsLimit = 12
      const rawRegister = JSON.parse(JSON.stringify(this.$store.getters.getRegister))
      let registerOutput = rawRegister.length ? rawRegister : [{}]
      const numberOfRegisterTables = Math.ceil(registerOutput.length / tableItemsLimit)
      let registerTables = []

      for (let index = 0; index < numberOfRegisterTables; index++) {
        registerTables.push(registerOutput.slice(0 + (index * tableItemsLimit), tableItemsLimit + (index * tableItemsLimit)))
      }

      return registerTables
    }
  },
  methods: {
    performPrint () {
      const sources = document.getElementsByClassName('session__register_print_page')
      const newDoc = new jsPDF('1', 'px', 'a4')
      const generateDoc = () => {
        newDoc.save(`${this.sessionEventName}-${this.sessionDates}.pdf`, { returnPromise: true }).then(() => {
          setTimeout(() => {
            window.close()
          }, 100)
        })
      }

      if (sources.length) {
        for (let index in sources) {
          const source = sources[index]
          if (source.constructor !== HTMLDivElement) continue

          html2canvas(source, { scale: 3 }).then(canvas => {
            let img = canvas.toDataURL('image/jpeg', 1)
            let w = source.offsetWidth
            let h = source.offsetHeight

            if (index > 0) {
              newDoc.addPage('1', 'px', 'a4')
              newDoc.setPage(Number(index) + 1)
            }

            newDoc.addImage(img, 'JPEG', 0, 0, (w / 2), (h / 2))

            if (Number(index) + 1 === sources.length) {
              generateDoc()
            }
          })
        }
      } else {
        generateDoc()
      }
    }
  },
  created () {
    this.$eventBus.$on('print-register', this.performPrint)
  },
  beforeDestroy () {
    this.$eventBus.$off('print-register')
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/sessions/sessionregisterprint";
</style>
